import storage from 'proxy-storage'
import getPlanTypeKey from 'core/controllerPlans/getPlanTypeKey'
import generatePlanFilter from 'utils/pivot/plan/generatePlanFilter'

function parseDefaultPlans(filterOptionsByProductType, plans, defaultPlansResponse) {
  const filtersByProductType = {}
  const hcStorage = storage.getItem('hc')

  const state = hcStorage.location.state_acronym

  const defaultPlans = defaultPlansResponse
    ? defaultPlansResponse[state] ?? defaultPlansResponse.default
    : []

  Object.keys(filterOptionsByProductType).forEach(key => {
    defaultPlans.forEach(planId => {
      const plan = plans[planId]
      const planKey = getPlanTypeKey(plan)
      if (key === planKey) {
        const planFilter = generatePlanFilter({
          plan,
          period: +hcStorage.period,
          policies: +hcStorage.policies
        })

        filtersByProductType[key] = planFilter
      }
    })
  })

  return filtersByProductType
}

export default parseDefaultPlans
